import React from "react";

import { Container } from "./styles";
import { useTour } from "hooks/useTour";

const TourOverlay: React.FC = () => {
  const { showTour } = useTour();
  return showTour && <Container />;
};

export default TourOverlay;
